(function() {
  function initStickyAddToCart() {
    const stickyBar = document.querySelector('[data-sticky-bar]');
    if (!stickyBar) return;

    function checkVisibility() {
      const mainBtn = document.querySelector('[name="add"].product-form__submit, button[id^="ProductSubmitButton"], .product-form__buttons, product-form');
      if (!mainBtn) return;

      const rect = mainBtn.getBoundingClientRect();
      if (rect.bottom < 0) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', checkVisibility, { passive: true });
    window.addEventListener('resize', checkVisibility, { passive: true });
    checkVisibility();

    // Variant Select handler in Sticky Bar
    const select = stickyBar.querySelector('[data-sticky-select]');
    const addBtn = stickyBar.querySelector('[data-sticky-add-btn]');
    const priceDisplay = stickyBar.querySelector('[data-sticky-price]');
    const mainImg = stickyBar.querySelector('[data-sticky-main-img]');

    if (select && select.tagName === 'SELECT') {
      select.addEventListener('change', function() {
        const selectedOpt = select.options[select.selectedIndex];
        if (!selectedOpt) return;

        const variantId = selectedOpt.value;
        const price = selectedOpt.getAttribute('data-price');
        const available = selectedOpt.getAttribute('data-available') === 'true';
        const img = selectedOpt.getAttribute('data-image');

        if (priceDisplay && price) {
          priceDisplay.textContent = price;
        }

        if (addBtn) {
          addBtn.setAttribute('data-variant-id', variantId);
          if (!available) {
            addBtn.disabled = true;
            addBtn.querySelector('.btn-text').textContent = 'Tükendi';
          } else {
            addBtn.disabled = false;
            addBtn.querySelector('.btn-text').textContent = 'Sepete Ekle';
          }
        }

        if (mainImg && img) {
          mainImg.src = img;
        }
      });
    }

    // Synchronize when variant changes on the main product page
    document.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant && select && select.tagName === 'SELECT') {
        select.value = e.detail.variant.id;
        select.dispatchEvent(new Event('change'));
      }
    });

    // Also observe DOM changes on Dawn variant picker
    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      const observer = new MutationObserver(function() {
        const currentVariantIdInput = productInfo.querySelector('input[name="id"]');
        if (currentVariantIdInput && select && select.tagName === 'SELECT') {
          if (select.value !== currentVariantIdInput.value) {
            select.value = currentVariantIdInput.value;
            select.dispatchEvent(new Event('change'));
          }
        }
      });
      observer.observe(productInfo, { childList: true, subtree: true });
    }

    // Add to Cart Action
    if (addBtn) {
      addBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;

        const variantId = addBtn.getAttribute('data-variant-id') || (select ? select.value : null);
        if (!variantId) return;

        addBtn.classList.add('is-loading');

        const rootUrl = window.Shopify?.routes?.root || '/';

        const formData = {
          id: variantId,
          quantity: 1,
          sections: 'cart-drawer,cart-icon-bubble'
        };

        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Add to cart failed');
          }
          return response.json();
        })
        .then(function(data) {
          addBtn.classList.remove('is-loading');
          addBtn.classList.add('is-success');

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
          } else if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }

          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sticky-add-to-cart', cartData: data });
          }

          setTimeout(function() {
            addBtn.classList.remove('is-success');
          }, 1500);
        })
        .catch(function(error) {
          console.error('Sticky add to cart error:', error);
          addBtn.classList.remove('is-loading');
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAddToCart);
  } else {
    initStickyAddToCart();
  }
})();
